import { customToast } from '@/components/Toast';
import { translateOutsideReact } from '@/i18n/client-translator';

export const copyToClipboard = async (text: string, toastMessage: string): Promise<void> => {
  try {
    const clipboard = typeof navigator === 'undefined' ? undefined : navigator.clipboard;
    if (typeof clipboard?.writeText !== 'function') {
      throw new Error('Clipboard unavailable');
    }
    await clipboard.writeText(text);
  } catch {
    customToast(translateOutsideReact('common.errors.clipboardCopyFailed'), { type: 'error', duration: 5000 });
    return;
  }

  customToast(toastMessage, { duration: 1500 });
};
